module.exports = __webpack_public_path__ + "img/logo-computa-blue.9ee3f7fd.svg";